/**
 * SSR-safe AsyncStorage getter for Zustand persist middleware.
 *
 * During Expo web export (SSR), `window` is undefined and AsyncStorage
 * (which delegates to localStorage on web) throws ReferenceError.
 * This returns a no-op storage on the server so stores initialize safely.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';

const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

export const getStorage = () =>
  typeof window === 'undefined' ? noopStorage : AsyncStorage;
